import React from 'react'
import renderImage from '../../../source/importImg'
import mismatchIcon from '../../../Assets/kitSelection/image.png'
import style from './DialogModal.module.css'
import fwStyle from '../FirmwareUpdateDialog/FirmwareUpdateDialog.module.css'

function DialogModal({
    show,
    text,
    connection,
    showCloseBtn,
    handleDialogModalClose,
    optionsToSelect,
    selectionShow,
    mismatchShow,
    showError,
    children,
    styles,
    boxClassName,
    progress,
    preventBackdropClose,
}) {
    // Helper to prevent click propagation to backdrop
    const stopProp = (e) => e.stopPropagation();
    const backdropClick = preventBackdropClose ? stopProp : handleDialogModalClose;

    return (
        <>
            {/* STANDARD MODAL */}
            {show && (
                <div className={style.container} onClick={backdropClick}>
                    <div className={`${style.box} ${boxClassName || ''}`} style={{ ...styles }} onClick={stopProp}>
                        {showCloseBtn && (
                            <img
                                className={style.closeBtn}
                                src={renderImage('clos')}
                                onClick={handleDialogModalClose}
                                alt="Close"
                            />
                        )}

                        <div className={style.text}>{text}</div>

                        {children && <>{children}</>}

                        <div className={style.btngroup}>
                            {optionsToSelect &&
                                optionsToSelect.map((option, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className={
                                            option.disabled
                                                ? style.btnDisabled
                                                : style.btn
                                        }
                                        onClick={option.do}
                                        disabled={option.disabled}
                                    >
                                        {option.text}
                                    </button>
                                ))}
                        </div>
                    </div>
                </div>
            )}

            {/* SELECTION MODAL */}
            {selectionShow && (
                <div className={style.selectionContainer} onClick={backdropClick}>
                    <div className={style.selectionbox} onClick={stopProp}>
                        <div className={style.selection_SubBox}>
                            {showCloseBtn && (
                                <img
                                    className={style.closeBtns}
                                    src={renderImage('clos')}
                                    onClick={handleDialogModalClose}
                                    alt="Close"
                                />
                            )}

                            <img
                                src={renderImage('settingImg')}
                                className={style.img}
                                alt="Settings"
                            />

                            <div className={style.text} style={{ marginTop: '2vh' }}>
                                {text}
                            </div>

                            <div className={style.btngroup}>
                                {optionsToSelect &&
                                    optionsToSelect.map((option, index) => (
                                        <button
                                            key={index}
                                            type="button"
                                            className={
                                                option.disabled
                                                    ? style.btns_disabled
                                                    : style.btns
                                            }
                                            onClick={option.do}
                                            disabled={option.disabled}
                                        >
                                            {option.text}
                                        </button>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* MISMATCH MODAL — styled to match the Firmware Update dialog */}
            {mismatchShow && (
                <div className={fwStyle.overlay} onClick={backdropClick}>
                    <div className={fwStyle.modal} onClick={stopProp}>
                        {showCloseBtn && (
                            <button
                                type="button"
                                aria-label="Close"
                                className={fwStyle.closeButton}
                                onClick={handleDialogModalClose}
                            />
                        )}

                        <div className={fwStyle.content}>
                            <div className={fwStyle.deviceInfo}>{text}</div>

                            <div className={fwStyle.actions}>
                                {optionsToSelect &&
                                    optionsToSelect.map((option, index) => (
                                        <button
                                            key={index}
                                            type="button"
                                            className={
                                                index === 0
                                                    ? fwStyle.updateButton
                                                    : fwStyle.skipButton
                                            }
                                            onClick={option.do}
                                        >
                                            {option.text}
                                        </button>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* CONNECTION SPINNER/ERROR */}
            {connection &&
                (!text.includes('unable') ? (
                    // LOADING STATE
                    <div className={style.connect_container1}>
                        <div className={style.connect_box1}>
                            <div className={style.connectingSpinner}>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div className={style.contentWrapper}>
                                {/* Text is now Grey/Black via CSS */}
                                <div className={style.content1}>{text}</div>
                                {/* Progress bar */}
                                {progress !== undefined && progress !== null && (
                                    <div className={style.progressBarContainer}>
                                        <div
                                            className={style.progressBarFill}
                                            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    // ERROR / ACTION STATE
                    <div className={style.connect_container} onClick={backdropClick}>
                        <div className={style.connect_box} onClick={stopProp}>
                            <div className={style.connect_SubBox}>
                                <div className={style.text}>
                                    <div className={style.error}>
                                        <img
                                            src="https://cdn-icons-png.flaticon.com/128/1304/1304037.png"
                                            alt="error"
                                        />
                                    </div>
                                    <div className={style.content}>{text}</div>
                                </div>
                                <div className={style.btngroup}>
                                    {optionsToSelect &&
                                        optionsToSelect.map((option, index) => (
                                            <button
                                                key={index}
                                                type="button"
                                                className={style.btns}
                                                onClick={option.do}
                                                disabled={option.disabled}
                                            >
                                                {option.text}
                                            </button>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            {/* ERROR MODAL (Reusable Mismatch Style) */}
            {showError && (
                <div className={style.mismatchContainer} onClick={backdropClick}>
                    <div className={style.mismatchbox} onClick={stopProp}>
                        <div className={style.mismatch_SubBox} style={{ position: 'relative', top: 'auto', left: 'auto', transform: 'none', padding: 0, boxShadow: 'none', border: 'none' }}>
                            {showCloseBtn && (
                                <img
                                    className={style.closeBtns}
                                    src={renderImage('clos')}
                                    onClick={handleDialogModalClose}
                                    alt="Close"
                                />
                            )}

                            <img
                                src={mismatchIcon}
                                className={style.img}
                                alt="Error"
                            />

                            <div className={style.text} style={{ marginTop: '2vh' }}>
                                {text}
                            </div>

                            <div className={style.btngroup}>
                                {optionsToSelect &&
                                    optionsToSelect.map((option, index) => (
                                        <button
                                            key={index}
                                            type="button"
                                            className={style.btns}
                                            onClick={option.do}
                                        >
                                            {option.text}
                                        </button>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default DialogModal